export const LOAD_SRA_TASKS = "LOAD_SRA_TASKS";

export const LOAD_SRA_TASKS_SUCCESS = "LOAD_SRA_TASKS_SUCCESS";

export const RESEND_COMPLETION_REQUEST = "RESEND_COMPLETION_REQUEST";

export const LOAD_SRA_RESULTS = "LOAD_SRA_RESULTS";

export const LOAD_SRA_RESULTS_SUCCESS = "LOAD_SRA_RESULTS_SUCCESS";

export const LOAD_TEAM_SRA_RESULTS = "LOAD_TEAM_SRA_RESULTS";

export const LOAD_TEAM_SRA_RESULTS_SUCCESS = "LOAD_TEAM_SRA_RESULTS_SUCCESS";
